import { render, staticRenderFns } from "./EnergyEfficiency.vue?vue&type=template&id=5b90648a&scoped=true&"
import script from "./EnergyEfficiency.vue?vue&type=script&lang=js&"
export * from "./EnergyEfficiency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b90648a",
  null
  
)

export default component.exports